import React from 'react';
import { CHANNEL_COLORS, CHANNEL_LABELS, ChannelBucket } from '../data/mockData';
import styles from './ChannelBadge.module.scss';

interface ChannelBadgeProps {
    bucket: ChannelBucket;
    label?: string;
}

export const ChannelBadge: React.FC<ChannelBadgeProps> = props => {
    return (
        <span className={styles.root}>
            <span
                className={styles.dot}
                style={{ backgroundColor: CHANNEL_COLORS[props.bucket] }}
            />
            {props.label ?? CHANNEL_LABELS[props.bucket]}
        </span>
    );
};

export default ChannelBadge;
